// Drop-in replacement for `import toast from 'react-hot-toast'` so ported
// components only need their import path changed. Backed by react-toastify,
// which flash already mounts (see App.tsx ToastContainer).
import { toast as rtToast } from 'react-toastify';

type ToastFn = ((message: string) => void) & {
	success: (message: string) => void;
	error: (message: string) => void;
};

const toast = ((message: string) => {
	rtToast(message);
}) as ToastFn;

toast.success = (message: string) => {
	rtToast.success(message);
};

toast.error = (message: string) => {
	rtToast.error(message);
};

export default toast;
